import { gql } from '@provision/graphql-client';

export const GET_ENTITY_VIEWER_QUERY = gql`
  query GetEntityViewer($params: GetEntityViewerInput!) {
    getEntityViewer(params: $params) {
      entity
      entityId
      items {
        status
        viewerId
        lastSeen
        firstName
        lastName
      }
      ts
    }
  }
`;

export const UPDATE_ENTITY_VIEWER_MUTATION = gql`
  mutation UpdateEntityViewer($params: UpdateEntityViewerInput!) {
    updateEntityViewer(params: $params) {
      success
    }
  }
`;
